import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SellerService } from 'src/app/core';
import { SellerRewardsDialogComponent } from 'src/app/shared';
import { PopupMessageService } from 'src/app/shared/message/services/message.service';

@Component({
  selector: 'app-approvaltracker-dialog',
  templateUrl: './approvaltracker-dialog.component.html',
  styleUrls: ['./approvaltracker-dialog.component.scss']
})
export class ApprovaltrackerDialogComponent implements OnInit {

  constructor(
    private sellerService:SellerService,
    @Inject(MAT_DIALOG_DATA) public data,
    private popupMessageService: PopupMessageService,  
    public dialogRef: MatDialogRef<SellerRewardsDialogComponent>,
  ) { }

  ngOnInit() {

    if(this.data.name=='resendData'){
      let val:any={};
      val.id=this.data.data.id;
      val.type=this.data.data.approvalTrackers[0].type;
      this.data.data=this.data.data.approvalTrackers[0];
      this.data.data=val;
    
    }
  }
  approvalFlag:boolean=false;
  sendMailToNotifyee: boolean = false;
  sendApprovalLink(type){
    this.approvalFlag=true;
    let approvaltype=type;
let reqParam='customChallengeId='+this.data.data.id+'&approvalType='+approvaltype+'&notifyPassiveRecipients='+this.sendMailToNotifyee;
this.sellerService.resendApprovalLink(reqParam).subscribe(data=>{
  if(data){
    this.approvalFlag=false;
    this.dialogRef.close({approvals:data})
    this.popupMessageService.showSuccess('Approval Link sent successfully', 'success');
  }
 
},
(err)=>{
  if (err.status == "412 - PRECONDITION_FAILED" || err.status == "409 - CONFLICT" )
  this.popupMessageService.showError(err.msg, "error");
  this.dialogRef.close({approvals:false})
}
)
//this.dialogRef.close()
}
}
